import type { QueryClient } from '@tanstack/react-query';
import { collectionKeys, type Collection } from './entity';

export function setCollectionCache(qc: QueryClient, workspaceId: number, c: Collection): void {
  qc.setQueryData(collectionKeys.detail(workspaceId, c.id), c);
}

export function getCollectionCache(qc: QueryClient, workspaceId: number, id: string): Collection | undefined {
  return qc.getQueryData<Collection>(collectionKeys.detail(workspaceId, id));
}

export function removeCollectionCache(qc: QueryClient, workspaceId: number, id: string): void {
  qc.removeQueries({ queryKey: collectionKeys.detail(workspaceId, id) });
}

export function invalidateCollectionLists(qc: QueryClient, workspaceId: number): void {
  void qc.invalidateQueries({ queryKey: collectionKeys.lists(workspaceId) });
}

export function setUpdatedCollectionCache(qc: QueryClient, workspaceId: number, updated: Collection): void {
  // Keep the server-derived fields an edit can't change, in case the response omits them.
  const merge = (prev: Collection | undefined): Collection =>
    prev == null ? updated : { ...updated, in_use: prev.in_use, rows: prev.rows, bytes: prev.bytes };

  qc.setQueryData<Collection>(collectionKeys.detail(workspaceId, updated.id), merge);

  qc.setQueriesData<Collection[]>({ queryKey: collectionKeys.lists(workspaceId) }, (rows) =>
    rows?.map((row) => (row.id === updated.id ? merge(row) : row)),
  );
}
